<script>
	let { labelLeft, labelBottom, content, bar, class: className } = $props();
</script>

<div class={[className, 'flex w-full flex-row']}>
	<div class="relative flex w-7">
		<p
			class="m-0 w-5 -rotate-90 p-0 text-sm leading-0 font-medium whitespace-nowrap"
			style="transform: translateY(50%) translateX(-150%); "
		>
			{labelLeft}
		</p>
	</div>
	<div class="grow-1">
		<ul
			class="border-indow-grey-dark mt-3 mb-0 flex w-full list-none flex-col gap-2 border-l-1 pt-3 pb-6 text-right font-bold text-white"
		>
			{#each content as { percent, title, color }, index (index)}
				<li style={`width:${percent}%`} class={`p-3 bg-indow-${color}`}>
					{title}
				</li>
			{/each}
		</ul>
		<ul
			class="ticks m-0 flex list-none flex-row justify-between text-sm font-medium"
		>
			{#each bar as b, index (index)}
				<li
					class="border-indow-grey-dark border-t-1 max-sm:even:[&_span]:opacity-0"
				>
					<span>{b}</span>
				</li>
			{/each}
		</ul>
		<p class="text-left text-sm font-medium">{labelBottom}</p>
	</div>
</div>

<style>
	.ticks li {
		position: relative;
		padding-top: 0.25rem;
		width: 100%;
	}
	.ticks li:not(:first-child) span {
		display: inline-block;
		transform: translateX(-50%);
	}
	.ticks li:after {
		content: '';
		position: absolute;
		height: 0.5rem;
		width: 1px;
		right: 0;
		top: -0.5rem;
		background-color: black;
	}
	.ticks li:last-child:after {
		visibility: hidden;
	}
	.ticks li:last-child {
		border: none;
		width: auto;
	}
</style>
